import React from "react";
import classNames from "classnames";
import { graphql, Script, ScriptStrategy } from "gatsby";
import parse from "html-react-parser";

import useVisibilityTracker from "@utils/hooks/useVisibilityTracker";

import SectionTitle from "@molecules/section-title/SectionTitle";

import * as styles from "@organisms/google-reviews/GoogleReviews.module.scss";

interface GoogleReviewsProps {
  data: {
    title: string;
    widgetId: string;
  };
}

const GoogleReviews = ({ data: { title, widgetId } }: GoogleReviewsProps): JSX.Element => {
  const { ref } = useVisibilityTracker("google-reviews", {
    threshold: 0.5,
  });

  return (
    <section ref={ref} className={classNames("or-google-reviews", styles.googleReviews)}>
      <SectionTitle title={parse(title)} />
      <div ref={ref} data-testid="google-reviews">
        <div className="embedsocial-reviews" data-ref={widgetId}></div>
      </div>
      <Script
        strategy={ScriptStrategy.idle}
        src={`https://embedsocial.com/embedscript/ri.js?${Math.random()}`}
        async
      />
    </section>
  );
};

export const query = graphql`
  fragment reviewsWidgetFragment on ContentfulReviewsWidget {
    title
    widgetId
  }
`;

export default GoogleReviews;
